/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostsmonthcost3Inputs */

const en_aicostsmonthcost3 = /** @type {(inputs: Aicostsmonthcost3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost this month`)
};

const de_aicostsmonthcost3 = /** @type {(inputs: Aicostsmonthcost3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosten im Monat`)
};

/**
* | output |
* | --- |
* | "Cost this month" |
*
* @param {Aicostsmonthcost3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostsmonthcost3 = /** @type {((inputs?: Aicostsmonthcost3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostsmonthcost3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostsmonthcost3(inputs)
	return de_aicostsmonthcost3(inputs)
});
export { aicostsmonthcost3 as "aiCostsMonthCost" }